import React from 'react';
import { Link } from 'react-router-dom';

function Test() {
  return (
    <div style={appContainer}>
      <header style={appHeader}>
        <h2 style={headerTitle}>Meta Search</h2>
      </header>

      <div style={contentBody}>
        <p style={sectionLabel}>Feature Demos</p>

        <Link to="/demo/graph" style={listItemStyle}>
          <div style={iconBox}>🌐</div>
          <div style={textLabel}>Gallery Graph</div>
          <span style={arrowStyle}>❯</span>
        </Link>
      </div>

      <footer style={appFooter}>
        <p>Meta WebView Demo</p>
      </footer>
    </div>
  );
}

const appContainer = {
  backgroundColor: '#F9F9F9',
  minHeight: '100vh',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
};

const appHeader = {
  backgroundColor: '#FFFFFF',
  padding: '20px',
  textAlign: 'left',
  borderBottom: '1px solid #EEEEEE',
  position: 'sticky',
  top: 0,
};

const headerTitle = {
  margin: 0,
  fontSize: '20px',
  fontWeight: 'bold',
  color: '#333',
};

const contentBody = { padding: '20px' };

const sectionLabel = {
  fontSize: '14px',
  color: '#888',
  marginBottom: '15px',
  fontWeight: '600',
};

const listItemStyle = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  padding: '16px',
  borderRadius: '12px',
  marginBottom: '12px',
  textDecoration: 'none',
  color: '#333',
  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
};

const iconBox = { marginRight: '15px', fontSize: '20px' };
const textLabel = { flex: 1, fontSize: '16px', fontWeight: '500' };
const arrowStyle = { color: '#CCC', fontSize: '14px' };

const appFooter = {
  marginTop: '40px',
  textAlign: 'center',
  color: '#BBB',
  fontSize: '12px',
};

export default Test;
